import { $, $$ } from './dom.js';


// This doesn't actually work becuse of CORS. Should move into server.

const getTitle = async (url) => {
  try {
    const html = await fetch(url).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const title = doc.querySelector('title').textContent;
    return title;
  } catch (error) {
    console.error('Error fetching title:', error);
    return null;
  }
};

// $('#url').onchange = async (e) => {
//   const title = await getTitle(e.target.value);
//   $('#text').value = title;
// };
